import * as React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import { useSimplifiedImportAtMount } from '../../hooks/useSimplifiedImportAtMount'

/**
 * Folds everything but the user's input behind a toggle for a guided first
 * import; a pass-through with no toggle for everyone else. `Collapse` keeps
 * children mounted, so hidden controls still reach the submit payload. The gate
 * is `useSimplifiedImportAtMount()` and nothing else — two gates drift.
 */
export default function AdvancedImportSettings({
    label = 'Show advanced settings',
    children,
}) {
    const collapsible = useSimplifiedImportAtMount()
    const [open, setOpen] = React.useState(false)

    if (!collapsible) return <>{children}</>

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 4,
                    marginBottom: 1,
                }}
            >
                <FormControlLabel
                    // Label first so the switch lands on the dialog's right edge.
                    labelPlacement="start"
                    sx={{ marginRight: 0 }}
                    control={
                        <Switch
                            checked={open}
                            onChange={event => setOpen(event.target.checked)}
                            inputProps={{
                                'data-testid': 'import-advanced-toggle',
                            }}
                        />
                    }
                    label={label}
                />
            </Box>
            <Collapse in={open}>
                <div data-testid="import-advanced-panel">{children}</div>
            </Collapse>
        </>
    )
}
